<div class="small-margin small-padding form-option-content" *ngIf="form.optionInfo">
  <p class="form-option-content">
    <b
      >Vous devez choisir {{ form.optionInfo.maxOptions === 1 ? 1 : '1 à ' + form.optionInfo.maxOptions }} option{{
        form.optionInfo.maxOptions === 1 ? '' : 's'
      }}
      parmi les suivantes :</b
    >
  </p>

  <div *ngFor="let opt of form.optionInfo.options" class="small-margin form-option-content">
    <input
      type="checkbox"
      [id]="opt.id"
      class="k-checkbox"
      [checked]="opt.subscribed"
      (change)="opt.subscribed = !opt.subscribed"
    />
    <label class="k-checkbox-label form-option-content" [for]="opt.id">{{ opt.libelle }}</label>
  </div>
  <div class="full-size align-right small-margin">
    <button
      kendoButton
      class="colored-text small-margin primary-color"
      (click)="goToNextStep()"
      [disabled]="form.optionInfo.maxOptions < countCheckedOptions() || countCheckedOptions() < 1"
    >
      Suivant
    </button>
  </div>
</div>
